<template>
  <div>
    <vue-seamless-scroll
      :data="listData"
      :class-option="classOption"
      class="warp"
    >
      <ul class="ul-item" >
        <li class="li-item" v-for="(item, index) in listData" :key="index" @click="$router.push('/open')">
          <div
            :style="{ 'background-image': `url(${$getFullPath(item.ornamentLevelImg)})` }"
            class="back"
          >
            <img v-if="item.ornamentsPrice==0.01" :src="$getFullPath(item.imageUrl)" class="itemImg" />
            <img v-else :src="item.imageUrl" class="itemImg" />
            <p class="textover-f">{{ item.holderUserNickName }}</p>
          </div>
        </li>
      </ul>
    </vue-seamless-scroll>
    <!-- <div class="notice-bar-div">
      <marquee
        :scrollamount="scrollamount"
        class="notice-bar"
        width="100%"
        behavior="scroll"
      >
        <div v-html="text"></div>
      </marquee>
      <img src="../assets/images/notice.png" class="notice-icon" alt="" />
    </div> -->
  </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
import { getWeapon, getArticle } from "@/api/index";

export default {
  name: "Example03Basic",

  components: {
    vueSeamlessScroll,
  },
  data() {
    return {
      timer: null,
      data: {
        page: 1,
        size: 20,
        orderByFie: 0,
        status: [0, 2, 3, 5],
        source: [1, 2, 3, 4],
        // ornamentLevelIds:[1]
      },
      scrollamount: 6,
      listData: [],
      text: null,
      classOption: {
        limitMoveNum: 2,
        direction: 2,
      },
    };
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  beforeCreate() {
    clearInterval(this.timer);
  },
  created() {
    this.getList();
    clearInterval(this.timer);
    this.timer = setInterval(() => {
      // getWeapon().then(res => {
      //   console.log(res);
      //   this.listData = res.data.rows;
      // });
    }, 5000);
  },
  methods: {
    getList() {
      getWeapon(this.data).then((res) => {
        this.listData = res.data.data;
        console.log("this.listData", this.listData);
      });
      getArticle("gg").then((res) => {
        this.text = res.data.data.contentList[0].content;
        console.log(res);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.itemImg {
  width: 40px;
  height: auto;
}
@media (max-width: 550px) {
  .warp {
    height: 80px*0.8 !important;
  }
  .li-item {
    width: 75px*0.8 !important;
    height: auto !important;
    font-size: 7px;
    img {
      width: 60px*0.8 !important;
      height: auto !important;
    }
  }
}
.notice-bar {
  width: 100%;
  margin: 0 auto;
  position: relative;
  width: 90%;
  height: 32px;
  font-size: 14px;
  color: #DAA520;
  display: flex;
  align-items: center;
  overflow-y: auto;
  margin-left: 40px;
  div {
    height: 32px;
  }
}
.warp {
  width: 100%;
  height: 112px*0.5;
  margin: 0 auto;
  overflow: hidden;
  ul {
    list-style: none;
    padding: 0;
    margin: 0 auto;
    &.ul-item {
      display: flex;
      .li-item {
        width: 105px*0.5;
        height: auto;
        margin-left: 10px;
        // background-color: #999;
        color: #DAA520;
        text-align: center;
        .back {
          padding: 4px;
          background-size: 100% 100% !important;
          // background: #212025;
        }
        p {
          text-align: center;
          font-size: 10px;
          color: #DAA520;
        }
      }
    }
  }
}
.notice-bar-div{
  position: relative;
}
.notice-icon {
  position: absolute;
  left: 10px;
  top: 0;
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
</style>
